import { useCallback } from "react";

import Typography from "@/foundation/Typography/V2";

import AllPackagesCarousel from "./AllPackagesCarousel";
import CallbackSection from "../CallbackSection";

import { classNameGenerator } from "@/utils";

import { useAppDispatch, useAppSelector } from "@/hooks";
import * as actions from "@/redux/BootCampReducer";

import styles from "./AllPackagesSection.module.scss";

interface AllPackagesSectionProps {}

const AllPackagesSection: React.FC<AllPackagesSectionProps> = () => {
  const dispatch = useAppDispatch();

  const cls = classNameGenerator(styles);

  const { data } = useAppSelector((state) => state.bootCamp);

  if(!data?.allPackages || data?.allPackages?.showOnBookingForm)
    return <></>

  const { allPackages } = data || {};
  const { title, description, packages } = allPackages || {};

  const setShowBookSlotModal = useCallback(
    (value: any) => {
      dispatch(actions.setShowBookSlotModal(value));
    },
    [dispatch]
  );

  if (!allPackages) {
    return <></>;
  }

  return (
    <section className={cls("allPackagesSection")} id="all-packages-section">
      <div className={cls("container")}>
        <div className={cls("heading")}>
          <Typography variant="heading2" className={cls("title")}>
            {title}
          </Typography>
          {description && (
            <Typography variant="paragraph1" className={cls("description")}>
              {description}
            </Typography>
          )}
          <div className={cls("callbackSectionWrapper")}>
            <CallbackSection variant="packages" />
          </div>
        </div>
        <div className={cls("content")}>
          <AllPackagesCarousel
            packages={packages}
            setShowBookSlotModal={setShowBookSlotModal}
          />
        </div>
      </div>
    </section>
  );
};

export default AllPackagesSection;
